import { parseMarkdown } from '@comark/nuxt/parse'
import breaks from '@comark/nuxt/plugins/breaks'
import security from '@comark/nuxt/plugins/security'
import autoFrontmatter from './autoFrontmatter'
import { textContent } from '@comark/nuxt/utils'

const allowedTags = ['p', 'span', 'ul', 'li', 'ol', 'strong']

export default function restrictedMarkdownPlugins() {
  return [
    security({
      allowedTags,
      tagFallback: (element) => textContent(element),
    }),
    breaks(),
  ]
}

export async function restrictedMarkdownDescription(value?: string) {
  if (!value) return undefined

  const document = await parseMarkdown(value, { plugins: [autoFrontmatter(), ...restrictedMarkdownPlugins()] })
  return document.frontmatter?.description
}
